// extracted by mini-css-extract-plugin
module.exports = {"text":"NewsletterSignupSection_text__p9KVI","textWrap":"NewsletterSignupSection_textWrap__DcST3","subText":"NewsletterSignupSection_subText__lzr93"};